import { render } from "./AddEditProducts.vue?vue&type=template&id=0b0f3adf&scoped=true"
import script from "./AddEditProducts.vue?vue&type=script&lang=js"
export * from "./AddEditProducts.vue?vue&type=script&lang=js"

import "./AddEditProducts.vue?vue&type=style&index=0&id=0b0f3adf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0f3adf"]])

export default __exports__